// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { InvoiceModel } from "@insite/client-framework/Types/ApiModels";
import ReturnRequestState from "@store/Framework/Store/Store/Pages/ReturnRequest/ReturnRequestState";
import { InvoiceRmaLine } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: ReturnRequestState = {
    invoiceRmaLines: {},
};

const actions = {
    "Store/Pages/ReturnRequest/SetInvoiceNumber": (
        draft: Draft<ReturnRequestState>,
        action: { invoiceNumber: string },
    ) => {
        draft.invoiceNumber = action.invoiceNumber;
    },
    "Store/Pages/ReturnRequest/SetInvoiceRmaLinesByInvoiceNumber": (
        draft: Draft<ReturnRequestState>,
        action: { invoice: InvoiceModel },
    ) => {
        if (!draft.invoiceRmaLines) {
            draft.invoiceRmaLines = {};
        }

        const invoiceLineMap: SafeDictionary<InvoiceRmaLine> = {};

        for (const invoiceLine of action.invoice.invoiceLines || []) {
            invoiceLineMap[invoiceLine.id] = {
                line: invoiceLine,
                rmaQtyRequested: 0,
                nonReturnableMessage:
                    ("nonReturnableMessage" in invoiceLine.properties && invoiceLine.properties.nonReturnableMessage) ||
                    "",
                isFridgeProduct:
                    "isFridgeProduct" in invoiceLine.properties && invoiceLine.properties.isFridgeProduct === "True",
                fridgeReference: "",
                returnReasonComments: "",
            } as InvoiceRmaLine;
        }

        draft.invoiceRmaLines[action.invoice.invoiceNumber] = invoiceLineMap;
    },
    "Store/Pages/ReturnRequest/UpdateInvoiceRmaLine": (
        draft: Draft<ReturnRequestState>,
        action: { invoiceNumber: string; invoiceRmaLine: InvoiceRmaLine },
    ) => {
        const invoiceLineMap: SafeDictionary<InvoiceRmaLine> = draft.invoiceRmaLines[action.invoiceNumber] || {};
        invoiceLineMap[action.invoiceRmaLine.line.id] = action.invoiceRmaLine;

        draft.invoiceRmaLines[action.invoiceNumber] = invoiceLineMap;
    },
    "Store/Pages/ReturnRequest/CompleteSubmitReturnRequestForm": (
        draft: Draft<ReturnRequestState>,
        action: { invoiceNumber: string },
    ) => {
        delete draft.invoiceRmaLines[action.invoiceNumber];
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreReturnRequestActions = Parameters<typeof reducer>[1];
export default reducer;
